
import { defineComponent, computed, ref, SetupContext } from 'vue';
import { validatorByIconSize, validatorByIconTheme } from './../../utils/validator';
import IconMap from './../../assets/icon';
import TIcon from './../t-icon/index';
import TLoading from './../t-loading/index';
type TIconMap = typeof IconMap;
type KTIconMap = keyof TIconMap;

export default defineComponent({
  name: 'TSpin',
  components: { TIcon, TLoading },
  props: {
    modelValue: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    iconTheme: {
      type: String,
      default: 'primary',
      validator: (value: string) => validatorByIconTheme(value),
    },
    size: {
      type: String,
      default: 'xlarge',
      validator: (value: string) => validatorByIconSize(value),
    },
    type: {
      type: String,
      default: 'static',
      validator: (value: string) => ['static', 'fixed'].includes(value),
    },
    theme: {
      type: String,
      default: 'default',
      validator: (value: string) => ['default', 'highlight'].includes(value),
    },
    src: {
      type: String,
      default: 'loading',
      validator: (value: KTIconMap) => IconMap[value] as any,
    },
    transparent: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click'],
  setup(props, context: SetupContext) {
    /** 组件的className前辍 */
    const prefixCls = ref('t-spin');
    /** 返回图标的默认主题配色 */
    const getTheme = computed(() => (props.theme === 'default' && props.type === 'fixed' ? 'highlight' : 'default'));
    /** 模板依赖的className */
    const getClasses = computed(() => {
      return {
        wrap: [
          prefixCls.value,
          props.type === 'fixed' && `${prefixCls.value}-fixed`,
          props.type === 'fixed' &&
            !props.transparent &&
            props.theme === 'highlight' &&
            `${prefixCls.value}-fixed__highlight`,
        ],
        content: [
          `${prefixCls.value}-cnt`,
          props.type === 'fixed' && `${prefixCls.value}-cnt__fixed`,
          props.type === 'fixed' && props.description && props.title && `${prefixCls.value}-cnt__large`,
          props.type === 'fixed' && `${prefixCls.value}-theme__${props.theme}`,
        ],
        title: [
          `${prefixCls.value}-title`,
          props.type === 'fixed' && `${prefixCls.value}-title__fixed`,
          props.type === 'fixed' && props.theme === 'highlight' && `${prefixCls.value}-title__highlight`,
          !props.description && `${prefixCls.value}-title__single`,
        ],
        description: [
          `${prefixCls.value}-desc`,
          props.type === 'fixed' && `${prefixCls.value}-desc__fixed`,
          props.type === 'fixed' && props.theme === 'highlight' && `${prefixCls.value}-desc__highlight`,
        ],
        iconWrap: [`${prefixCls.value}-icon`],
      };
    });

    /** 对外响应的事件 */
    const listener = (event: any) => context.emit('click', event);

    return { prefixCls, getClasses, getTheme, listener };
  },
});
